export enum StaffRole {
  OWNER = 'owner',
  ADMIN = 'admin',
  CSM = 'csm',
  AE = 'ae',
}
